import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Paginacao } from '../../comum/modelos/paginacao';
import { RoteiroService } from '../roteiro.service';
import { PontoFisicoService } from '../../ponto-fisico/ponto-fisico.service';
import { ComumService } from '../../comum/comum.service';
import { Roteiro } from '../../comum/modelos/roteiro';
import { RoteiroPontoFisico } from '../../comum/modelos/roteiro-ponto-fisico';
import { Usuario } from '../../comum/modelos/usuario';
import { UsuarioService } from '../../usuario/usuario.service';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { AgendaRoteiroPontoFisico } from '../../comum/modelos/agenda-roteiro-ponto-fisico';
import { ConfirmationService } from 'primeng/primeng';
import { CookieService } from 'angular2-cookie/core';
import { AuthService } from '../../auth/auth.service';
import { SetorService } from '../../setor/setor.service';
import { ProcessoService } from '../../processo/processo.service';
import { RotinaService } from '../../rotina/rotina.service';
import { PontoFisico } from '../../comum/modelos/ponto-fisico';
import { SetorPontoFisico } from '../../comum/modelos/setor-ponto-fisico';
import { ProcessoSetor } from '../../comum/modelos/processo-setor';
import { RotinaProcesso } from '../../comum/modelos/rotina-processo';
import { AgendaRoteiroSetor } from '../../comum/modelos/agenda-roteiro-setor';
import { AgendaRoteiroProcesso } from '../../comum/modelos/agenda-roteiro-processo';
import { AgendaRoteiroRotina } from '../../comum/modelos/agenda-roteiro-rotina';


@Component({
    selector: 'app-cadastro-roteiro',
    templateUrl: './cadastro-roteiro.component.html',
    styleUrls: ['./cadastro-roteiro.component.css']
})
export class CadastroRoteiroComponent implements OnInit {

    roteiro: Roteiro;
    usuarios: Usuario[];
    pontosFisicosSelecionados: boolean;
    paginacaoPontosFisicos: Paginacao;
    MODO: string;
    CADASTRAR = 'Cadastrar';
    ATUALIZAR = 'Atualizar';
    statusCode: number;
    value: Date[];
    dateFormat = 'dd/mm/yy';
    pt: any;
    public loading = false;
    minimumDate = new Date();

    constructor (
        private _comumService: ComumService,
        private _roteiroService: RoteiroService,
        private _pontoFisicoService: PontoFisicoService,
        private _usuarioService: UsuarioService,
        private _activatedRoute: ActivatedRoute,
        private router: Router,
        private confirmationService: ConfirmationService,
        private _cookieService: CookieService,
        private _authService: AuthService,
        private _setorService: SetorService,
        private _processoService: ProcessoService,
        private _rotinaService: RotinaService) {
        this.paginacaoPontosFisicos = new Paginacao();
        this.roteiro = new Roteiro();
        this.usuarios = new Array<Usuario>();
    }

    ngOnInit() {
        this.pt = {
            firstDayOfWeek: 1,
            dayNames: ['domingo', 'segunda', 'ter\xE7a', 'quarta', 'quinta', 'sexta', 's\xE1bado'],
            dayNamesShort: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 's\xE1b'],
            dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
            monthNames: ['janeiro', 'fevereiro', 'mar\xE7o', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro',
                'outubro', 'novembro', 'dezembro'],
            monthNamesShort: ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'],
            today: 'Hoje',
            clear: 'Apagar'
        };
        this.loading = true;
        this.paginacaoPontosFisicos.itens = 5;
        this.paginacaoPontosFisicos.page = 1;
        const self = this;
        const idRoteiro = self._activatedRoute.snapshot.params['id'];
        const u = self._usuarioService.obterUsuariosHttp(parseInt(this._cookieService.get('idCliente'), 10));
        const pf = self._pontoFisicoService.obterPontosFisicoClienteHttp(parseInt(this._cookieService.get('idCliente'), 10));

        if (idRoteiro !== undefined) {
            self.MODO = self.ATUALIZAR;
            const pfr = self._roteiroService.obterPontosFisicosRoteiroHttp(idRoteiro);
            forkJoin(this._roteiroService.obterRoteiroHttp(idRoteiro), pf, u, pfr)
                .subscribe(([roteiro, pontosFisicos, usuarios, pontosFisicosRoteiro]) => {
                    self.roteiro = roteiro;
                    self.roteiro.dataInicioRoteiro = new Date(roteiro.dataInicioRoteiro);
                    self.roteiro.dataFimRoteiro = new Date(roteiro.dataFimRoteiro);
                    self.usuarios = usuarios;
                    // Associa pontos fisicos aos roteiros
                    const pfRoteiro = new Array<RoteiroPontoFisico>();
                    for (const pontoFisico of pontosFisicos) {
                        const novoPontoFisicoRoteiro = new RoteiroPontoFisico();
                        novoPontoFisicoRoteiro.pontoFisico = pontoFisico;
                        novoPontoFisicoRoteiro.idRoteiro = idRoteiro;
                        for (const pontoFisicoRoteiro of pontosFisicosRoteiro) {
                            if (pontoFisicoRoteiro.pontoFisico.idPontoFisico === pontoFisico.idPontoFisico) {
                                novoPontoFisicoRoteiro.idRoteiroPontoFisico = pontoFisicoRoteiro.idRoteiroPontoFisico;
                                for (const agenda of pontoFisicoRoteiro.agendas) {
                                    if (novoPontoFisicoRoteiro.pontoFisico.datasAgenda === undefined) {
                                        novoPontoFisicoRoteiro.pontoFisico.datasAgenda = new Array<Date>();
                                    }
                                    novoPontoFisicoRoteiro.pontoFisico.datasAgenda.push(new Date(agenda.dataAgenda));
                                    const agendaRoteiroPontoFisico = new AgendaRoteiroPontoFisico();
                                    agendaRoteiroPontoFisico.idAgendaRoteiroPontoFisico = agenda.idAgendaRoteiroPontoFisico;
                                    agendaRoteiroPontoFisico.idRoteiroPontoFisico = agenda.idRoteiroPontoFisico;
                                    agendaRoteiroPontoFisico.idPontoFisico = pontoFisicoRoteiro.pontoFisico.idPontoFisico;
                                    agendaRoteiroPontoFisico.dataAgenda = new Date(agenda.dataAgenda);
                                    agendaRoteiroPontoFisico.idRoteiro = agenda.idRoteiro;
                                    agendaRoteiroPontoFisico.selecionado = true;
                                    novoPontoFisicoRoteiro.agendas.push(agendaRoteiroPontoFisico);
                                }
                                novoPontoFisicoRoteiro.selecionado = true;
                                break;
                            }
                        }
                        pfRoteiro.push(novoPontoFisicoRoteiro);
                    }
                    self.roteiro.pontosFisicos = pfRoteiro;
                    this.loading = false;
                });
        } else {
            self.MODO = self.CADASTRAR;
            forkJoin(pf, u)
                .subscribe(([pontosFisicos, usuarios]) => {
                    self.usuarios = usuarios;
                    for (const pontoFisico of pontosFisicos) {
                        const novoPontoFisico = new RoteiroPontoFisico();
                        novoPontoFisico.pontoFisico = pontoFisico;
                        self.roteiro.pontosFisicos.push(novoPontoFisico);
                    }
                    self.loading = false;
                });
        }
    }

    onSubmit(): void {
        this.loading = true;
        const self = this;
        if (self.MODO === self.CADASTRAR) {
            self.roteiro.idCliente = parseInt(this._cookieService.get('idCliente'), 10);
            self._roteiroService.cadastrarRoteiroHttp(self.roteiro)
                .subscribe(response => {
                    self.inserirPontosFisicosRoteiro(response.body.idRoteiro);
                    self.statusCode = response.status;
                    self._comumService.evento.cadastro = true;
                    self.router.navigate(['listar-roteiros']);
                }, errorCode => {
                    self.statusCode = errorCode;
                    self.loading = false;
                });
        } else {
            self._roteiroService.atualizarRoteiroHttp(self.roteiro)
                .subscribe(response => {
                    self.inserirPontosFisicosRoteiro(self.roteiro.idRoteiro);
                    self.statusCode = response.status;
                    self._comumService.evento.atualizar = true;
                    self.router.navigate(['listar-roteiros']);
                    console.log(response.status);
                }, errorCode => {
                    self.statusCode = errorCode;
                    self.loading = false;
                });
        }
        self.loading = false;
        self.router.navigate(['listar-roteiros']);
    }

    inserirPontosFisicosRoteiro(idRoteiro: number): void {
        this.loading = true;
        const pontosFisicosRoteiroInsert = new Array<RoteiroPontoFisico>();
        const pontosFisicosRoteiroRemove = new Array<RoteiroPontoFisico>();
        const datasAgendaInsert = new Array<AgendaRoteiroPontoFisico>();
        const datasAgendaRemove = new Array<AgendaRoteiroPontoFisico>();
        this.roteiro.pontosFisicos.forEach(pontoFisico => {
            if (!pontoFisico.selecionado && pontoFisico.idRoteiroPontoFisico !== undefined && pontoFisico.alterado) {
                pontosFisicosRoteiroRemove.push(pontoFisico);
                pontoFisico.agendas.forEach(agenda => {
                    const now = new Date();
                    if (agenda.dataAgenda < new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()))
                        || agenda.idAgendaRoteiroPontoFisico === undefined) {
                        pontoFisico.agendas.splice(pontoFisico.agendas.indexOf(agenda), 1);
                    }
                });
            } else if (pontoFisico.selecionado && pontoFisico.idRoteiroPontoFisico === undefined
                && pontoFisico.alterado) {
                pontoFisico.idRoteiro = idRoteiro;
                pontoFisico.agendas.forEach(agenda => {
                    if (!agenda.selecionado && !agenda.alterado) {
                        pontoFisico.agendas.splice(pontoFisico.agendas.indexOf(agenda), 1);
                        if (agenda.idAgendaRoteiroPontoFisico !== undefined) {
                            datasAgendaRemove.push(agenda);
                        }
                    }
                });
                pontosFisicosRoteiroInsert.push(pontoFisico);
            } else if (pontoFisico.selecionado && pontoFisico.idRoteiroPontoFisico !== undefined) {
                pontoFisico.agendas.forEach(agenda => {
                    if (agenda.selecionado && agenda.alterado && agenda.idAgendaRoteiroPontoFisico === undefined) {
                        datasAgendaInsert.push(agenda);
                    } else if (!agenda.selecionado && agenda.alterado && agenda.idAgendaRoteiroPontoFisico !== undefined) {
                        datasAgendaRemove.push(agenda);
                    }
                });
            }
        });

        forkJoin(this._roteiroService.cadastrarPontosFisicosRoteiroHttp(pontosFisicosRoteiroInsert),
            this._roteiroService.removerPontosFisicosRoteiroHttp(pontosFisicosRoteiroRemove),
            this._roteiroService.cadastrarAgendasPontosFisicosRoteiroHttp(datasAgendaInsert),
            this._roteiroService.removerAgendasPontosFisicosRoteiroHttp(datasAgendaRemove)
        ).subscribe(([pfInseridos, pfRemovidos, datasInsert, datasRemove]) => {
            if (datasInsert.body.length > 0) {
                this.adicionarParametros(datasInsert.body);
            }
        }, errorCode => {
            this.statusCode = errorCode;
            this.loading = false;
        });

        this.loading = false;
    }

    adicionarParametros(datasInsert: AgendaRoteiroPontoFisico[]) {
        const pontosFisicosAdicionados = new Array<PontoFisico>();
        datasInsert.forEach(agenda => {
            const pontoFisico = new PontoFisico();
            pontoFisico.idPontoFisico = agenda.idPontoFisico;
            pontosFisicosAdicionados.push(pontoFisico);
        });
        let setoresPontoFisicoAdicionados = new Array<SetorPontoFisico>();
        let processosSetorAdicionados = new Array<ProcessoSetor>();
        let rotinasProcessoAdicionados = new Array<RotinaProcesso>();
        const agendasRoteiroSetor = new Array<AgendaRoteiroSetor>();
        const agendasRoteiroProcesso = new Array<AgendaRoteiroProcesso>();
        const agendasRoteiroRotina = new Array<AgendaRoteiroRotina>();
        this._setorService.obterSetoresPontosFisicosHttp(pontosFisicosAdicionados)
            .subscribe(setoresPontoFisico => {
                setoresPontoFisicoAdicionados = setoresPontoFisico;
                this._processoService.obterProcessosSetoresHttp(setoresPontoFisicoAdicionados)
                    .subscribe(processosSetor => {
                        processosSetorAdicionados = processosSetor;
                        this._rotinaService.obterRotinasProcessosHttp(processosSetorAdicionados)
                            .subscribe(rotinasProcesso => {
                                rotinasProcessoAdicionados = rotinasProcesso;
                                datasInsert.forEach(agenda => {
                                    setoresPontoFisico.forEach(setorPontoFisico => {
                                        const agendaRoteiroSetor = new AgendaRoteiroSetor();
                                        agendaRoteiroSetor.idAgendaRoteiroPontoFisico = agenda.idAgendaRoteiroPontoFisico;
                                        agendaRoteiroSetor.idSetorPontoFisico = setorPontoFisico.idSetorPontoFisico;
                                        agendasRoteiroSetor.push(agendaRoteiroSetor);
                                    });
                                    processosSetor.forEach(processoSetor => {
                                        const agendaRoteiroProcesso = new AgendaRoteiroProcesso();
                                        agendaRoteiroProcesso.idAgendaRoteiroPontoFisico = agenda.idAgendaRoteiroPontoFisico;
                                        agendaRoteiroProcesso.idProcessoSetor = processoSetor.idProcessoSetor;
                                        agendasRoteiroProcesso.push(agendaRoteiroProcesso);
                                    });
                                    rotinasProcesso.forEach(rotinaProcesso => {
                                        const agendaRoteiroRotina = new AgendaRoteiroRotina();
                                        agendaRoteiroRotina.idAgendaRoteiroPontoFisico = agenda.idAgendaRoteiroPontoFisico;
                                        agendaRoteiroRotina.idRotinaProcesso = rotinaProcesso.idRotinaProcesso;
                                        agendasRoteiroRotina.push(agendaRoteiroRotina);
                                    });
                                });
                                console.log(agendasRoteiroSetor);
                                forkJoin(this._roteiroService.cadastrarAgendasRoteiroSetorHttp(agendasRoteiroSetor),
                                    this._roteiroService.cadastrarAgendasRoteiroProcessoHttp(agendasRoteiroProcesso),
                                    this._roteiroService.cadastrarAgendasRoteiroRotinaHttp(agendasRoteiroRotina))
                                    .subscribe(([agendasSetor, agendasProcesso, agendasRotina]) => {
                                    });
                            });
                    });
            });
    }

    selecionarPontoFisico(pontoFisicoRoteiro: RoteiroPontoFisico): void {
        pontoFisicoRoteiro.selecionado = !pontoFisicoRoteiro.selecionado;
        pontoFisicoRoteiro.alterado = true;
    }

    selecionarTodosPontosFisicos(): void {
        this.pontosFisicosSelecionados = !this.pontosFisicosSelecionados;
        this.roteiro.pontosFisicos.forEach(pontoFisico => {
            pontoFisico.selecionado = this.pontosFisicosSelecionados;
            pontoFisico.alterado = true;
        });
    }

    validarDataInicio(event: any) {
        const oldDate = this.roteiro.dataInicioRoteiro;
        this.roteiro.dataInicioRoteiro = this.roteiro.dataInicioRoteiro;
        for (const pontoFisicoRoteiro of this.roteiro.pontosFisicos) {
            for (const agenda of pontoFisicoRoteiro.agendas) {
                if (agenda.dataAgenda < event) {
                    this.confirmationService.confirm({
                        rejectVisible: false,
                        message: 'Loja selecionada fora deste per\u00edodo',
                        accept: () => {
                            this.roteiro.dataInicioRoteiro = oldDate;
                        },
                        reject: () => {
                        }
                    });
                    break;
                }
            }
        }
    }

    validarDataFim(event: any) {
        const oldDate = this.roteiro.dataFimRoteiro;
        for (const pontoFisicoRoteiro of this.roteiro.pontosFisicos) {
            for (const agenda of pontoFisicoRoteiro.agendas) {
                if (agenda.dataAgenda > event) {
                    this.confirmationService.confirm({
                        rejectVisible: false,
                        message: 'Loja selecionada fora deste per\u00edodo',
                        accept: () => {
                            this.roteiro.dataFimRoteiro = oldDate;
                        },
                        reject: () => {
                        }
                    });
                    break;
                }
            }
        }
    }

    selecionarData(event: any, pontoFisicoRoteiro: RoteiroPontoFisico) {
        const allDates = new Set<number>();
        event.forEach((data: Date) => {
            allDates.add(data.getTime());
        });
        for (const pontoFisico of this.roteiro.pontosFisicos) {
            if (pontoFisico.idRoteiroPontoFisico === pontoFisicoRoteiro.idRoteiroPontoFisico) {
                pontoFisico.agendas.forEach(agenda => {
                    allDates.add(agenda.dataAgenda.getTime());
                });
                allDates.forEach(data => {
                    if (pontoFisico.agendas.find(agenda => agenda.dataAgenda.getTime() === data) === undefined) {
                        const agendaRoteiroPontoFisico = new AgendaRoteiroPontoFisico();
                        agendaRoteiroPontoFisico.idRoteiro = pontoFisico.idRoteiro;
                        agendaRoteiroPontoFisico.idRoteiroPontoFisico = pontoFisico.idRoteiroPontoFisico;
                        agendaRoteiroPontoFisico.idPontoFisico = pontoFisico.pontoFisico.idPontoFisico;
                        agendaRoteiroPontoFisico.dataAgenda = new Date(data);
                        agendaRoteiroPontoFisico.selecionado = true;
                        agendaRoteiroPontoFisico.alterado = true;
                        pontoFisico.agendas.push(agendaRoteiroPontoFisico);
                    } else if (pontoFisicoRoteiro.agendas.find(agenda => agenda.dataAgenda.getTime() === data) !== undefined) {
                        const agendaRoteiroPontoFisico = pontoFisicoRoteiro.agendas.find(agenda => agenda.dataAgenda.getTime() === data);
                        if (event.find((dataAgenda: Date) => dataAgenda.getTime() === data) === undefined) {
                            if (agendaRoteiroPontoFisico.idAgendaRoteiroPontoFisico !== undefined) {
                                agendaRoteiroPontoFisico.selecionado = false;
                                agendaRoteiroPontoFisico.alterado = true;
                                pontoFisico.agendas.splice(pontoFisico.agendas.indexOf(pontoFisicoRoteiro.agendas.find(
                                    agenda => agenda.dataAgenda.getTime() === data)), 1);
                                pontoFisico.agendas.push(agendaRoteiroPontoFisico);
                            } else {
                                pontoFisico.agendas.splice(pontoFisico.agendas.indexOf(pontoFisicoRoteiro.agendas.find(
                                    agenda => agenda.dataAgenda.getTime() === data)), 1);
                            }
                        } else {
                            agendaRoteiroPontoFisico.selecionado = true;
                            agendaRoteiroPontoFisico.alterado = true;
                            pontoFisico.agendas.splice(pontoFisico.agendas.indexOf(pontoFisicoRoteiro.agendas.find(
                                agenda => agenda.dataAgenda.getTime() === data)), 1);
                            pontoFisico.agendas.push(agendaRoteiroPontoFisico);
                        }
                    }
                });
                break;
            }
        }
    }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/roteiro/cadastro-roteiro/cadastro-roteiro.component.ts